import React, { useEffect, useState } from 'react';
import './Navbar.css';
import logo from '../../assets/jimmy.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBars,
    faBolt,
    faCalculator,
    faCalendarDays,
    faCircleUser,
    faFileLines,
    faFolderOpen,
    faHouse,
    faScaleBalanced,
    faUserTie,
} from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { auth, db } from '../../firebase/firebaseConfig';
import { doc, onSnapshot } from 'firebase/firestore';
import SideMenu from './SideMenu';

const navItems = [
    { label: 'Início', route: '/', icon: faHouse },
    { label: 'Documentos', route: '/jimmy', icon: faFileLines },
    { label: 'Calendário', route: '/calendario', icon: faCalendarDays },
    { label: 'Jurisearch', route: '/jurisprudencia', icon: faScaleBalanced },
    { label: 'Calculadora', route: '/calculadora', icon: faCalculator },
    { label: 'Modelos', route: '/modelos', icon: faFolderOpen },
    { label: 'Clientes', route: '/areadocliente', icon: faUserTie },
];

const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isSideMenuActive, setSideMenuActive] = useState(false);
    const [showSideMenu, setShowSideMenu] = useState(false);
    const [profilePhoto, setProfilePhoto] = useState(null);
    const [photoLoadFailed, setPhotoLoadFailed] = useState(false);

    useEffect(() => {
        let unsubscribe;

        if (auth.currentUser) {
            const docRef = doc(db, `usuarios/${auth.currentUser.email}`);
            unsubscribe = onSnapshot(docRef, (docSnap) => {
                if (docSnap.exists()) {
                    setPhotoLoadFailed(false);
                    setProfilePhoto(docSnap.data().photoURL || null);
                }
            }, (error) => {
                console.error('Erro ao acompanhar a foto de perfil:', error);
            });
        }

        return () => unsubscribe?.();
    }, []);

    useEffect(() => {
        if (isSideMenuActive) {
            setShowSideMenu(true);
            return undefined;
        }

        const timer = setTimeout(() => setShowSideMenu(false), 220);
        return () => clearTimeout(timer);
    }, [isSideMenuActive]);

    const handleNavigation = (route) => {
        if (route === '/calendario') {
            sessionStorage.removeItem('clienteSelecionado');
        }
        setSideMenuActive(false);
        navigate(route);
        sessionStorage.setItem('currentRoute', route);
    };

    const isActive = (route) => (
        route === '/'
            ? location.pathname === '/'
            : location.pathname === route || location.pathname.startsWith(`${route}/`)
    );

    if (location.pathname.includes('/cliente/')) {
        return null;
    }

    return (
        <header className="navbar">
            <button className="navbar-brand" onClick={() => handleNavigation('/')} type="button" aria-label="Ir para o início">
                <img src={logo} alt="Jimmy" className="logo" />
                <span className="navbar-brand-copy">
                    <strong>Workspace jurídico</strong>
                    <small>Operação centralizada</small>
                </span>
            </button>

            <nav className="container-lista-navbar" aria-label="Navegação principal">
                <ul className="ul-navbar">
                    {navItems.map((item) => (
                        <li key={item.route}>
                            <button
                                className={`li-navbar ${isActive(item.route) ? 'active' : ''}`}
                                onClick={() => handleNavigation(item.route)}
                                type="button"
                                aria-current={isActive(item.route) ? 'page' : undefined}
                                title={item.label}
                            >
                                <FontAwesomeIcon icon={item.icon} />
                                <span>{item.label}</span>
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>

            <div className="navbar-actions">
                <span className="navbar-model" title="Modelo jurídico Jimmy-A1">
                    <FontAwesomeIcon icon={faBolt} />
                    Jimmy-A1
                </span>

                <button className="profile-button" onClick={() => navigate('/perfil')} type="button" aria-label="Abrir perfil">
                    {profilePhoto && !photoLoadFailed ? (
                        <img
                            src={profilePhoto}
                            alt=""
                            className="navbar-profile-image"
                            onError={() => setPhotoLoadFailed(true)}
                        />
                    ) : (
                        <FontAwesomeIcon icon={faCircleUser} className="user-fallback" />
                    )}
                </button>

                <button
                    className="menu-toggle"
                    onClick={() => setSideMenuActive(true)}
                    type="button"
                    aria-label="Abrir menu"
                >
                    <FontAwesomeIcon icon={faBars} />
                </button>
            </div>

            {showSideMenu && (
                <SideMenu
                    handleNavigation={handleNavigation}
                    closeMenu={() => setSideMenuActive(false)}
                    isActive={isSideMenuActive}
                />
            )}
        </header>
    );
};

export default Navbar;
